module.exports = __webpack_public_path__ + "img/participant-faciliti.ab465f15.svg";